import React, { useState } from 'react';
import { FLAG } from '../../constants';
import NoFlagShield from './NoFlagShield';
import './styles.scss';

export default function TeamBadge({ name, shortName, flagUrl, abbreviateTeamNamesOnMobile, noFlagPlaceholderSrc }) {
  const flagSrc = flagUrl || FLAG[name];
  const [imgError, setImgError] = useState(false);
  const hasFlag = Boolean(flagSrc) && !imgError;
  const abbrevMobile = shortName || (!hasFlag
    ? "PD"
    : String(name || "")
        .slice(0, 3)
        .toUpperCase());

  return (
    <div className="team-badge">
      {hasFlag ? (
        <div className="team-badge__flag">
          <img src={flagSrc} onError={() => setImgError(true)} style={{ width: '40px', height: 'auto' }} />
          </div>
      ) : (
        <div className="team-badge__placeholder">
          {noFlagPlaceholderSrc ? (
            <img
              src={noFlagPlaceholderSrc}
              alt=""
              className="team-badge__placeholder-image"
            />
          ) : (
            <NoFlagShield />
          )}
        </div>
      )}
      <div className="team-badge__name">
        {abbreviateTeamNamesOnMobile ? (
          <>
            <span className="team-badge__name-text team-badge__name-text--full">
              {name}
            </span>
            <span className="team-badge__name-text team-badge__name-text--abbrev">
              {abbrevMobile}
            </span>
          </>
        ) : (
          <span>{name}</span>
        )}
      </div>
    </div>
  );
}
